// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__rQW0w","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3jfef","obliqueLine":"membershipbadge_obliqueLine__y_Z8t"};